// extracted by mini-css-extract-plugin
module.exports = {"fixedCalculatorFooter":"FixedCalculatorFooter_fixedCalculatorFooter__INfGs"};